import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Badge from 'components/base/Badge';

const Class = () => {
  const classes = [
    {
      id: 1,
      name: 'Web Development Basics',
      instructor: 'John Doe',
      students: 25,
      status: 'active',
    },
    {
      id: 2,
      name: 'React Advanced',
      instructor: 'Jane Smith',
      students: 18,
      status: 'active',
    },
    {
      id: 3,
      name: 'Node.js Fundamentals',
      instructor: 'Mike Johnson',
      students: 22,
      status: 'completed',
    },
    {
      id: 4,
      name: 'Database Design',
      instructor: 'Sarah Wilson',
      students: 15,
      status: 'upcoming',
    },
  ];

  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'active':
        return <Badge variant="phoenix" bg="success">active</Badge>;
      case 'completed':
        return <Badge variant="phoenix" bg="secondary">completed</Badge>;
      case 'upcoming':
        return <Badge variant="phoenix" bg="warning">upcoming</Badge>;
      default:
        return <Badge variant="phoenix" bg="secondary">{status}</Badge>;
    }
  };

  return (
    <Container fluid>
      <Row className="g-3 mb-3">
        <Col>
          <h2 className="mb-0">Classes</h2>
        </Col>
      </Row>
      <Row className="g-3">
        {classes.map((classItem) => (
          <Col key={classItem.id} md={6} lg={4}>
            <Card className="h-100 shadow-sm">
              <Card.Header className="bg-body-emphasis">
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="mb-0 fw-semibold">{classItem.name}</h6>
                  {getStatusBadge(classItem.status)}
                </div>
              </Card.Header>
              <Card.Body>
                <div className="mb-3">
                  <small className="text-body-secondary fw-medium">Instructor:</small>
                  <p className="mb-0 text-body-emphasis">{classItem.instructor}</p>
                </div>
                <div className="mb-0">
                  <small className="text-body-secondary fw-medium">Students:</small>
                  <p className="mb-0 text-body-emphasis">{classItem.students}</p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Class;
